import axios from 'axios'

import config from '../../config'

const updateInspectionReminder = (params = {}, data) => {
  const { airportId } = params

  const url = `${config.baseUrl}/${airportId}/Reminders/Inspection`
  return axios.put(url, data)
}

export default updateInspectionReminder
